import React from "react";
import Header from "../components/Header";
import { Footer } from "../components/Footer";
import PatientReportInformationPageReactQuill from "../views/patientInformation/patientReportInformationPageNewReactQuill";

const PatientReportInformationNewReactQuill = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Header />
      <PatientReportInformationPageReactQuill />
      <Footer />
    </>
  );
};

export default PatientReportInformationNewReactQuill;
